// extracted by mini-css-extract-plugin
export default {"homepage-hero":"homepage-hero---i0RV","homepageHero":"homepage-hero---i0RV","container":"container--MKR3v","media":"media--mf3ba","text":"text--pLDbo"};